// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infoL[data-v-64667e2e]{width:23.75vw;height:auto;float:left}.infoR[data-v-64667e2e]{width:70vw;height:14.583vw;float:left;margin-left:1.25vw;position:relative}.infoR .typeChart[data-v-64667e2e]{width:100%;height:11.667vw;position:absolute;left:0;bottom:0}", ""]);
// Exports
module.exports = exports;
